import { useQuery, type QueryClient } from '@tanstack/react-query';
import { api } from '@/lib/axios';

export interface DropLogRow {
  itemIcon: string;
  itemName: string;
  charName16: string;
  refObjId: number;
  map: string;
  monsterName: string | null;
  codeName128: string;
  dropDate: string;
  id64: number;
  charId: number;
  isLocked: boolean;
  isRare: boolean;
}

export const DROP_LOGS_QUERY_KEY = ['logsystem'] as const;

export async function fetchDropLogs(): Promise<DropLogRow[]> {
  const { data } = await api.get<{ status: string; data: { drops: DropLogRow[] } }>(
    '/api/v1/logsystem',
  );
  return data.data?.drops ?? [];
}

export function useDropLogs() {
  return useQuery({
    queryKey: DROP_LOGS_QUERY_KEY,
    queryFn: fetchDropLogs,
    staleTime: 60_000,
    placeholderData: (prev) => prev,
  });
}

export function prefetchDropLogs(queryClient: QueryClient): void {
  void queryClient.prefetchQuery({
    queryKey: DROP_LOGS_QUERY_KEY,
    queryFn: fetchDropLogs,
    staleTime: 60_000,
  });
}
